import { doAjax} from './helper'

const initSeatSelect = () => {
	//const seatLeatherImg = document.querySelector('.display .image-wrap .item')
	//const seatStitchImg = document.querySelector('.display .image-wrap .overlay')
	//const leatherTiles = document.querySelectorAll('.leather-tiles .color')
	//const stitchTiles = document.querySelectorAll('.seam-tiles .color')

	//DISABLE BUTTONS 
	let submit = document.getElementById("navigation-submit-btn");
	let options = document.querySelectorAll(".seat-selection");
	submit.setAttribute("disabled", true);
	for (let option of options) {
		if (option.querySelector(".is-checked")) {
			submit.removeAttribute("disabled");
		}
		option.addEventListener("click", () => {
			submit.removeAttribute("disabled");
		});
	}

	//SAVE STATE 
	const seatSelections = document.querySelectorAll('.aui-radio.aui-js-radio input')
	seatSelections.forEach(seatSelection => {
		seatSelection.addEventListener('click',(element)=>{
			doAjax({
				choose_seat_selection: element.target.value
			});
		})
	})

	
}




export { initSeatSelect };